import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent } from "../../../common/component/Index";
import Page from './../../../../../models/Page';
import { withTranslation } from "react-i18next";
import { Icon, Menu } from 'antd';
import Ripple from '../../../common/component/Ripple';
import { PATHS, TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import moment from "moment";
import Modal from '../../../common/component/Modal';
import Dropdown from '../../../common/component/Dropdown';
import { FlagIcons } from '../../../common/component/TranslateButton';
import { toArray } from 'lodash';

const ListCols = ['title', 'createdDate', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new Page());
class PageList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                title: {
                    key: 'title',
                },
                createdDate: {
                    width: 150,
                    key: 'createdDate',
                    render: (date, record) => moment(moment.utc(date).toDate().toJSON()).format('DD-MM-YYYY HH:mm'),
                },
                translations: {
                    key: 'languageCode',
                    filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                        value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                    })),
                    filterMultiple: false,
                    width: 120,
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                },
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, pages } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="page-list"
                rowKey={record => record.id}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(pages || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'page'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeItem = () => {
            return this.props.onDeletePage && this.props.onDeletePage(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.page.title_page`)),
                content: item.title,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeItem,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.PAGE.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }

                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }


}

export default withTranslation()(PageList);
